import { action } from '@ember/object';
import { PrismComboSelectInput } from '@mylighthouse/prism-ember';
import BasePropertySelect, {
  type PropertyOption,
} from 'lumen/components/settings/users/base-property-select';

interface AddPropertyAccessSignature {
  Args: {
    onAdd: (subscriptionIds: number[]) => Promise<void>;
    userId: string;
  };
}

const EMPTY_SELECTION: PropertyOption[] = [];

export default class AddPropertyAccess extends BasePropertySelect<AddPropertyAccessSignature> {
  protected override get fetchParams(): Record<string, string | number> {
    return { ...super.fetchParams, user: this.args.userId };
  }

  @action
  buildLabel(count: number): string {
    if (count === 0) {
      return this.intl.t('settings.users.add_property.trigger_label');
    }

    return this.intl.t('settings.users.add_property.trigger_label_with_count', {
      count,
    });
  }

  @action
  async handleChange(selectedOptions: PropertyOption[]): Promise<void> {
    if (selectedOptions.length === 0) {
      return;
    }

    const subscriptionIds = selectedOptions.map((property) =>
      Number(property.id),
    );

    await this.args.onAdd(subscriptionIds);
  }

  <template>
    <div data-test-id="add-property-access">
      <PrismComboSelectInput
        @buildLabelWithCount={{this.buildLabel}}
        @isSearchable={{true}}
        @onChange={{this.handleChange}}
        @onOpen={{this.onOpen}}
        @onSearch={{this.onSearch}}
        @options={{this.options}}
        @unsafe_onLoadMore={{this.loadMoreTask.perform}}
        @value={{EMPTY_SELECTION}}
      />
    </div>
  </template>
}
